function TopMainvisual(){
	this.$window = $(window);
	this.imgWidth = 4000;
	this.imgHeight = 1850;

	this.init();
}

TopMainvisual.prototype = {
	init: function(){
		this.setPositionWidth('.mt__link--debug', 2852, 362, 567);
		this.setPositionWidth('.mt__link--localize', 774, 790, 898);
		this.setPositionWidth('.mt__link--illust', 1906, 0, 921);
		this.setPositionWidth('.mt__link--promo', 1011, 82, 930);
		this.setPositionWidth('.mt__link--print', 226, 316, 923);

		this.setPosition('.mt__icon--debug', 3107, 967);
		this.setPosition('.mt__icon--localize', 1333, 1263);
		this.setPosition('.mt__icon--illust', 2458, 324);
		this.setPosition('.mt__icon--promo', 1311, 236);
		this.setPosition('.mt__icon--print', 804, 430);

		this.setPosition('.mt__balloon--debug', 2930, 1127);
		this.setPosition('.mt__balloon--localize', 1184, 1461);
		this.setPosition('.mt__balloon--illust', 2329, 534);
		this.setPosition('.mt__balloon--promo', 1116, 438);
		this.setPosition('.mt__balloon--print', 560, 570);

		this.setPosition('.mt__obj--print', 215, 316);

		//this.setPosition('.mt__airship01', 1506, 748);
		//this.setPosition('.mt__airship02', 1506, 748);

		this.setPositionWidth('.mt__airship--wrap', 1506, 748, 1492);

		// $('.mt__airship01, .mt__airship02').css({
		// 	transform: 'translate(200%, 0)'
		// });
		$('.mt__airship').addClass('is--visible');

		// $(document).on('mouseover', '.mt__balloon', function(){
		// 	$(this).addClass('is--mouseover');
		// });
		// $(document).on('mouseout', '.mt__balloon', function(){
		// 	$(this).removeClass('is--mouseover');
		// });
	},
	setPositionWidth :function(el,r,b,w){
		$(el).css({
			right: this.getRightValue(r),
			bottom: this.getBottomValue(b),
			width: this.getWidthValue(w)
		});
	},
	setPosition :function(el,r,b){
		$(el).css({
			right: this.getRightValue(r),
			bottom: this.getBottomValue(b)
		});
	},
	getRightValue: function(n){
		return n * this.getImgReduction() - this.getImgOverflowWidth();
	},
	getBottomValue: function(n){
		return n * this.getImgReduction();
	},
	getWidthValue: function(n){
		return n * this.getImgReduction();
	},
	getImgAspect: function(){
		return this.imgWidth / this.imgHeight;
	},
	getWindowWidth: function(){
		return this.$window.width();
	},
	getWindowHeight: function(){
		return this.$window.height();
	},
	getImgReduction: function(){
		return this.getWindowHeight() / this.imgHeight;
	},
	getImgReductionWidth: function(){
		return this.imgWidth * this.getImgReduction();
	},
	getImgOverflowWidth: function(){
		return (this.getImgReductionWidth() - this.getWindowWidth()) / 2;
	}
}






module.exports = TopMainvisual;



// WEBPACK FOOTER //
// ./es2015/_top_mainvisual.js